export const EXPERIMENT_KEY = 'cross-flow-defer-edition-communication';
